export default __webpack_public_path__ + "static/media/cha1.d5039fe3.png";